// This is the number of megabytes we need to add to maxBufferSize for
// every second we add to maxMax, assuming most content is 720p at about
// 2.5 Mbps, with some padding for safety. The default on most platforms
// is 60 sec and 30 MB; the setup below ensures we have at least 30 MB at
// 60 sec and then increases the buffer size slightly larger than
// proportionately to ensure it is not a constraint on the maximum
// unit is megabytes per second (not megabits!)
const CONVERSION_FACTOR = 0.6 * 1000 * 1000;

// The default value for maxBufferSize in hlsjs is 60 MB
// so we use this as an effective minimum in the calculation
const BASE_SIZE = 1000 * 1000 * 60;

// This is the base maxMaxBufferLength in seconds
const BASE_MAX_MAX = 60;

/**
 * Given a certain maxMaxBufferLength in seconds, figures out how large a value
 * we need for maxBufferSize so as to ensure that for 720p content, the
 * maxBufferSize never acts as a constraint.
 *
 * Why is this needed? To set a max size for the hlsjs buffer, it is necessary
 * to modify both maxMaxBufferLength and maxBufferSize, as hlsjs determines a
 * buffer maximum by looking at the least of these two values after converting
 * maxBufferSize to seconds based on the estimated bitrate of the current
 * level
 */
export function getBufferSizeFromBufferLength({ maxMaxBufferLength }: {maxMaxBufferLength: number}) {
  return BASE_SIZE + ((maxMaxBufferLength - BASE_MAX_MAX) * CONVERSION_FACTOR);
}
